export const PlanEnumDev = Object.freeze({
	IFS_MAPPING_TRIAL_7D: "78531",

	GENOGRAM_CLASS_YEARLY: "72209",
	GENOGRAM_YEARLY: "72072",
	GENOGRAM_MONTHLY: "72073",
	GENOGRAM_MONTHLY_TRIAL: "72382",
	GENOGRAM_LIFETIME: "64942",
	PERSONAL_TOUCH_YEARLY: "70054",
	PERSONAL_TOUCH_MONTHLY: "70053",
	ULTIMATE_YEARLY: "70056",
	ULTIMATE_YEARLY_DISCOUNT: "70055",
	PERSONAL_TOUCH_TRIAL: "10550",
	WHEEL_OF_LIFE_TRIAL: "72328",
	QWOACH_TOOLS_DEV: "68528",
	QWOACH_MAIN: "762957",
	CORE_CONTRIBUTOR: "569425",
	ESSENTIALS: "752045",
	INFOSTACK_SPECIAL: "601237",
	CONTRIBUTOR_SPECIAL: "601238"
});
